module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "budget-followup"
  }, [(_vm.data && !_vm.loading) ? _c('div', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "15px",
      "margin-bottom": "30px"
    }
  }, [_vm._v("\n            Du har lagt budget for perioden "), _c('b', [_vm._v(_vm._s(_vm._f("moment")(_vm.data.from, 'DD/MM/YYYY')) + " - " + _vm._s(_vm._f("moment")(_vm.data.to, 'DD/MM/YYYY')))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticClass: "employee-switcher",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('div', {
    staticClass: "employee-switcher-option lg",
    class: {
      'selected': _vm.selectedSubMenuItem === 'hours'
    },
    on: {
      "click": function($event) {
        _vm.selectedSubMenuItem = 'hours'
      }
    }
  }, [_vm._v("\n                    Solgte timer\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "employee-switcher-option lg",
    class: {
      'selected': _vm.selectedSubMenuItem === 'cph'
    },
    on: {
      "click": function($event) {
        _vm.selectedSubMenuItem = 'cph'
      }
    }
  }, [_vm._v("\n                    DB pr. time\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "employee-switcher-option lg",
    class: {
      'selected': _vm.selectedSubMenuItem === 'ebitda'
    },
    on: {
      "click": function($event) {
        _vm.selectedSubMenuItem = 'ebitda'
      }
    }
  }, [_vm._v("\n                    EBITDA\n                ")])])]), _vm._v(" "), _c('budget-hours', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedSubMenuItem === 'hours'),
      expression: "selectedSubMenuItem === 'hours'"
    }]
  }), _vm._v(" "), _c('budget-cph', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedSubMenuItem === 'cph'),
      expression: "selectedSubMenuItem === 'cph'"
    }]
  }), _vm._v(" "), _c('budget-ebitda', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedSubMenuItem === 'ebitda'),
      expression: "selectedSubMenuItem === 'ebitda'"
    }]
  })], 1) : (!_vm.data && !_vm.loading) ? _c('div', [_c('div', {
    staticClass: "placeholder padding",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n            Du har endnu ikke lagt et budget\n            "), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "budget-btn",
    attrs: {
      "to": {
        name: 'BudgetPlanning'
      },
      "tag": "button"
    }
  }, [_vm._v("\n                Læg et budget\n            ")])], 1)]) : _c('div', [_c('box-loading')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a626fa8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/economy/learning/budgetFollowup.vue
// module id = 797
// module chunks = 0